import React from "react";

export default function ValentineFrame3({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 2000 2000"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls3-1{fill:#e98ead}.cls3-2{fill:#27141a}"}</style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_3"
          data-name="\u0421\u043B\u043E\u0439 3"
        >
          <path
            className="cls3-1"
            d="m1460.37 1613.22 39.9-34.3-93.48-.09-47.54 46.11h149.6l47.54-46.11h-40.66ZM1457.32 1673.76l-44.32-31.68 33.79 31.68h-40l-47.54-46.1h149.6l47.54 46.1ZM1143.17 1687.43c13.16-3.33 23.15-14.77 25.5-26.26 2.42-11.88-3.5-24.42-15.32-33.8 11.5-9.77 17-22.51 14.16-34.3-2.78-11.58-13.27-22.42-26.38-25.38-23.07-5.21-48.2 15.41-78 39.83a309.31 309.31 0 0 0-23.87 21.75v.08c4.49 4 11 9.64 19.07 16 34.01 26.65 61.36 48.04 84.84 42.08Z"
          />
          <rect
            className="cls3-2"
            x={1122.95}
            y={1622.05}
            width={395.3}
            height={11.21}
            rx={5.6}
          />
          <path
            className="cls3-1"
            d="m871.55 1613.22 39.9-34.3-93.48-.09-47.54 46.11H920l47.54-46.11h-40.63ZM868.5 1673.76l-44.33-31.68 33.83 31.68h-40l-47.54-46.1H920l47.54 46.1ZM554.34 1687.43c13.17-3.33 23.16-14.77 25.5-26.26 2.43-11.88-3.49-24.42-15.31-33.8 11.49-9.77 17-22.51 14.16-34.3-2.78-11.58-13.27-22.42-26.38-25.38-23.08-5.21-48.2 15.41-78 39.83a309.31 309.31 0 0 0-23.87 21.75v.08c4.49 4 10.94 9.64 19.06 16 34.02 26.65 61.37 48.04 84.84 42.08Z"
          />
          <rect
            className="cls3-2"
            x={534.13}
            y={1622.05}
            width={395.3}
            height={11.21}
            rx={5.6}
          />
          <path
            className="cls3-1"
            d="M389.78 1454.18q17.14 20 34.3 39.91l.09-93.48-46.11-47.54v149.59l46.11 47.55v-40.66ZM329.24 1451.14l31.68-44.33-31.68 33.79v-40l46.1-47.54v149.59l-46.1 47.55ZM315.56 1137c3.34 13.17 14.78 23.15 26.27 25.5 11.88 2.43 24.42-3.49 33.8-15.31 9.77 11.49 22.51 17 34.3 14.15 11.58-2.78 22.42-13.26 25.38-26.37 5.21-23.08-15.41-48.21-39.83-78a309.31 309.31 0 0 0-21.75-23.87h-.08c-4 4.49-9.64 10.94-16 19.06-26.65 33.99-48.04 61.34-42.09 84.84Z"
          />
          <rect
            className="cls3-2"
            x={177.7}
            y={1308.81}
            width={395.3}
            height={11.21}
            rx={5.6}
            transform="rotate(90 375.345 1314.415)"
          />
          <path
            className="cls3-1"
            d="m389.78 865.36 34.3 39.9.09-93.47-46.11-47.55v149.6l46.11 47.54v-40.65ZM329.24 862.31 360.92 818l-31.68 33.79v-40l46.1-47.55v149.6l-46.1 47.54ZM315.56 548.16c3.34 13.16 14.78 23.15 26.27 25.5 11.88 2.42 24.42-3.5 33.8-15.32 9.77 11.5 22.51 17 34.3 14.16 11.58-2.78 22.42-13.27 25.38-26.38 5.21-23.07-15.41-48.2-39.83-78a307 307 0 0 0-21.75-23.86h-.08c-4 4.48-9.64 10.94-16 19.06-26.65 34.01-48.04 61.36-42.09 84.84Z"
          />
          <rect
            className="cls3-2"
            x={177.7}
            y={719.99}
            width={395.3}
            height={11.21}
            rx={5.6}
            transform="rotate(90 375.345 725.595)"
          />
          <path
            className="cls3-1"
            d="m546.5 386.78-39.9 34.3 93.48.09 47.54-46.11H498l-47.54 46.11h40.66ZM549.55 326.24l44.33 31.68-33.79-31.68h40l47.54 46.1H498l-47.54-46.1ZM863.71 312.57c-13.17 3.33-23.16 14.77-25.5 26.26-2.43 11.88 3.49 24.42 15.31 33.8-11.49 9.77-17 22.51-14.16 34.3 2.78 11.58 13.27 22.42 26.38 25.38 23.08 5.21 48.2-15.41 78-39.83a309.31 309.31 0 0 0 23.87-21.75v-.08c-4.49-4-10.94-9.64-19.06-16-34.02-26.65-61.37-48.04-84.84-42.08Z"
          />
          <rect
            className="cls3-2"
            x={488.62}
            y={366.74}
            width={395.3}
            height={11.21}
            rx={5.6}
            transform="rotate(180 686.27 372.345)"
          />
          <path
            className="cls3-1"
            d="m1135.33 386.78-39.91 34.3 93.48.09 47.54-46.11h-149.6l-47.54 46.11h40.7ZM1138.37 326.24l44.33 31.68-33.79-31.68h40l47.54 46.1h-149.6l-47.54-46.1ZM1452.53 312.57c-13.17 3.33-23.15 14.77-25.5 26.26-2.43 11.88 3.49 24.42 15.31 33.8-11.49 9.77-17 22.51-14.15 34.3 2.78 11.58 13.26 22.42 26.37 25.38 23.08 5.21 48.21-15.41 78-39.83a309.31 309.31 0 0 0 23.87-21.75v-.08c-4.49-4-10.94-9.64-19.06-16-34.01-26.65-61.37-48.04-84.84-42.08Z"
          />
          <rect
            className="cls3-2"
            x={1077.45}
            y={366.74}
            width={395.3}
            height={11.21}
            rx={5.6}
            transform="rotate(180 1275.095 372.345)"
          />
          <path
            className="cls3-1"
            d="M1610.22 540.32q-17.15-20-34.3-39.91l-.09 93.48 46.11 47.54V491.84l-46.11-47.54V485ZM1670.76 543.37l-31.68 44.32 31.68-33.79v40l-46.1 47.54v-149.6l46.1-47.54ZM1684.44 857.52c-3.34-13.17-14.78-23.15-26.27-25.5-11.88-2.43-24.42 3.49-33.8 15.31-9.77-11.49-22.51-17-34.3-14.15-11.58 2.78-22.42 13.26-25.38 26.38-5.21 23.07 15.41 48.2 39.83 78a308.85 308.85 0 0 0 21.75 23.86h.08c4-4.48 9.64-10.94 16-19.06 26.65-34.01 48.04-61.36 42.09-84.84Z"
          />
          <rect
            className="cls3-2"
            x={1427.01}
            y={674.48}
            width={395.3}
            height={11.21}
            rx={5.6}
            transform="rotate(-90 1624.655 680.085)"
          />
          <path
            className="cls3-1"
            d="m1610.22 1129.14-34.3-39.9-.09 93.48 46.11 47.54v-149.6l-46.11-47.54v40.66ZM1670.76 1132.19l-31.68 44.32 31.68-33.79v40l-46.1 47.54v-149.6l46.1-47.54ZM1684.44 1446.34c-3.34-13.16-14.78-23.15-26.27-25.5-11.88-2.42-24.42 3.5-33.8 15.32-9.77-11.5-22.51-17-34.3-14.16-11.58 2.78-22.42 13.27-25.38 26.38-5.21 23.07 15.41 48.2 39.83 78a309.31 309.31 0 0 0 21.75 23.87h.08c4-4.48 9.64-10.94 16-19.06 26.65-34.02 48.04-61.37 42.09-84.85Z"
          />
          <rect
            className="cls3-2"
            x={1427.01}
            y={1263.3}
            width={395.3}
            height={11.21}
            rx={5.6}
            transform="rotate(-90 1624.655 1268.905)"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
